import Form from "components/form/Form";
import CopyMapModal from "pages/CompetencyMaps/view/components/CopyMapModal";
import { useState } from "react";
import ViewGridLayout from "layout/ViewGridLayout";
import withHeightFitContent from "hocs/withHeightFitContent";
import useScrollMemory from "hooks/useScrollMemory";
import { ConstructorTabContext } from "../../context";
import LeftColumn from "./LeftColumn";
import { ConstructorTabProps } from "./types";
import RightColumn from "./RightColumn";

const LeftColumnWithHeightFitContent = withHeightFitContent(LeftColumn);

const ConstructorTab = ({
  fieldArray,
  form,
  isEditable,
  competencyMap,
  refetchCompetencyMapGenQuestionsLog,
  ...props
}: ConstructorTabProps) => {
  const [skillsIdsToDelete, setSkillsIdsToDelete] = useState<string[]>([]);
  const [openCopyModal, setOpenCopyModal] = useState<boolean>(false);
  const { ref } = useScrollMemory({ timeoutDelay: 700 });

  return (
    <ConstructorTabContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{ skillsIdsToDelete, setSkillsIdsToDelete, refetchCompetencyMapGenQuestionsLog }}>
      <Form form={form}>
        <ViewGridLayout
          containerSx={{ flexWrap: "nowrap", flexDirection: { md: "row", xs: "column-reverse" } }}
          LeftColumn={
            <LeftColumnWithHeightFitContent
              fieldArray={fieldArray}
              form={form}
              isEditable={isEditable}
              refProp={ref}
            />
          }
          RightColumn={
            <RightColumn
              form={form}
              isEditable={isEditable}
              competencyMap={competencyMap}
              setOpenCopyModal={setOpenCopyModal}
              refetchCompetencyMapGenQuestionsLog={refetchCompetencyMapGenQuestionsLog}
              {...props}
            />
          }
        />
      </Form>
      {openCopyModal && competencyMap && (
        <CopyMapModal
          open={openCopyModal}
          onClose={() => setOpenCopyModal(false)}
          originalMap={{ id: competencyMap.id, title: competencyMap.title }}
        />
      )}
    </ConstructorTabContext.Provider>
  );
};

export default ConstructorTab;
